import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "teachers",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "school-teacherSetup" */ "./TeacherSetup"),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "SchoolSetup/modules/SchoolSetupModule"
      ),
      import(
        /* webpackChunkName: "admin-teacherSetup" */ "TeacherSetup/modules/Module"
      ),
    ]).then(([importedModule0, importedModule1, importedModule2]) => {
      const component = importedModule0.default;
      const schoolSetupReducer = importedModule1.default;
      const teacherSetupReducer = importedModule2.default;

      injectReducer(store, {
        key: "schoolSetup",
        reducer: schoolSetupReducer,
      });

      injectReducer(store, {
        key: importedModule2.NAME,
        reducer: teacherSetupReducer,
      });

      return component;
    })
  ),
  childRoutes: [],
});
